import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by mx-auto"> Created with ♥ by Study Clinic 2025</span>
     
  `,
})
export class FooterComponent {
}
